/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-11-14 17:15:24
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-03-19 16:28:54
 * @FilePath: \xyjh-web\src\utils\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @Author: gongzhichao
 * @Date: 2023-04-27 16:39:00
 * @Description: 公共方法
 */

const utils = {
  // 区分微信浏览器
  isWeiXinBrowser: () => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },

  // 区分移动端类型
  isMobileType: () => {
    let type = "";
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/android/i) == "android") {
      type = "android";
    }
    if (ua.match(/iphone/i) == "iphone") {
      type = "ios";
    }
    if (ua.match(/ipad/i) == "ipad") {
      type = "ios";
    }
    return type;
  },

  // 区分客户端类型
  isClientType: () => {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Macintosh|Mac OS x|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      return "mobile";
    } else {
      return "pc";
    }
  },

  // HTMLDecode
  decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  },

  // 转换树形结构
  toTree(arr) {
    let newA = JSON.parse(JSON.stringify(arr));
    return newA.filter((p) => {
      const c = newA.filter((item) => item.parentId === p.id);
      c.length && (p.list = c);
      return p.parentId === 39;
    });
  },

  toText(html) {
    return html
      .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
      .replace(/<[^>]+?>/g, "")
      .replace(/\s+/g, " ")
      .replace(/&nbsp;|&gt;|&lt;|&amp;|&ldquo;|&rdquo;|&mdash;|\s+/g, " ")
      .replace(/ /g, " ")
      .replace(/>/g, " ");
  },

  doCopy(text, successInfo = "复制成功", failInfo = "复制失败") {
    return new Promise((resolve, reject) => {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const successful = document.execCommand("copy");
        if (!successful) throw new Error(failInfo);
        document.body.removeChild(textArea);
        textArea = null;
        resolve(successInfo);
      } catch (err) {
        console.info(err);
        reject(failInfo);
      }
    });
  },
};

export default utils;
